module.exports = __webpack_public_path__ + "img/logo.42399825.png";